import { Box, Button } from '@mui/material';
import React from 'react';
import { useIntl } from 'react-intl';

interface props {
  rebookCloser: (value: boolean) => void;
  handleRequest: () => Promise<void>;
  dataChanged: boolean;
  cancelHandler: () => void;
}

const SearchAlternatives: React.FC<props> = ({ rebookCloser, handleRequest, dataChanged, cancelHandler }) => {
  const intl = useIntl();
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          height: '100%',
          marginTop: '25px',
          padding: '0',
        }}
      >
        <Button
          color="info"
          style={{
            backgroundColor: '#F4F4F7',
            borderRadius: '3px',
            color: '#09295D',
            borderColor: '#09295D',
            border: '1px solid',
          }}
          onClick={() => {
            rebookCloser(false);
            cancelHandler();
          }}
        >
          {intl.formatMessage({ id: 'ndc.rebookCancel' })}
        </Button>
        <Button
          color="info"
          style={{
            backgroundColor: dataChanged ? '#092A5E' : 'grey',
            color: 'white',
            borderRadius: '3px',
            paddingLeft: 16,
            paddingRight: 16,
          }}
          onClick={() => handleRequest()}
          disabled={!dataChanged}
        >
          {intl.formatMessage({ id: 'rebook.searchAlternatives' })}
        </Button>
      </Box>
    </>
  );
};

export default SearchAlternatives;
